import script from "./AgentDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentDetails.vue?vue&type=script&lang=ts&setup=true"

import "./AgentDetails.vue?vue&type=style&index=0&id=60672367&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60672367"]])

export default __exports__